module.exports = __webpack_public_path__ + "static/media/coin.9030239a.svg";